import {
    useShowController, Show, TopToolbar
} from 'react-admin';
import ClassroomShow from '../classrooms/classroomShow';
import { makeStyles } from '@mui/styles';
import BasicBreadcrumbs from '../../components/breadcrumb';

const useStyles = makeStyles((theme) => ({
    topToolbar: {
        minHeight: 2
    }
}));

const SessionShow = () => {

    const { record, isLoading } = useShowController();
    const classes = useStyles();

    const SessionShowActions = () => {
        return (
            <TopToolbar className={classes.topToolbar}>
            </TopToolbar>
        )
    };

    return (
        <div>
            {record ? <BasicBreadcrumbs name={record.name} /> : ''}
            <Show resource='sessions' actions={<SessionShowActions />}>
                {!isLoading && record.room ? <ClassroomShow id={record.room} resource="classrooms" showTraining='true' /> : null}
            </Show>
        </div>
    )
};

export default SessionShow;